import { Helmet } from "react-helmet";
import SideDashboard from "../dashboard/dashboard";
import PhotoGuide from "../content/photo/photo";
import { NavLink } from "react-router-dom";
import allImages from "../../utils/images";
import TestNav from "../testNav/testNav";
import useFsService from "../../services/fsService";
import { useEffect, useState } from "react";
import Spinner from "../spinner/spinner";
import ErrorScreen from "../error/error";
import { useTranslation } from "react-i18next";

const PhotoPage = () => {
  const { t } = useTranslation();
  const { startNewTest, error, loading, errorText } = useFsService();
  const [hasError, setHasError] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const initTest = async () => {
      try {
        const res = await startNewTest();

        if (res) {
          setIsInitialized(true);
        } else {
          setHasError(true);
        }
      } catch (e) {
        setHasError(true);
      }
    };

    initTest();
  }, []);

  const errorMessage = hasError || error ? <ErrorScreen errorText={errorText} /> : null;
  const spinner = loading ? <Spinner /> : null;
  const content = isInitialized && !loading && !hasError ? <View /> : null;

  return (
    <>
      <Helmet>
        <meta
          name="description"
          content={t("photo.metaDescription", "Анализ фото")}
        />
        <title>{t("photo.pageTitle", "Анализ фотографии")}</title>
      </Helmet>
      <main>
        {spinner}
        {errorMessage}
        {content}
      </main>
    </>
  );
};

const View = () => {
  const { t } = useTranslation();

  return (
    <>
      <aside className="dashboard">
        <SideDashboard type={"test"} />
      </aside>
      <NavLink className="mob__logo" to="/">
        <img src={allImages.DashLogoWebp} alt={t("photo.logoAlt", "Логотип")} />
      </NavLink>
      <aside className="mob__nav">
        <TestNav />
      </aside>
      <PhotoGuide title={t("photo.photoGuideTitle", "Инструкция по анализу")} />
    </>
  );
};

export default PhotoPage;
